import SsrCodes from "./SsrCodes";

export default SsrCodes;